import { useTranslation } from "react-i18next";
import { NavLink, useLocation, Outlet } from "react-router-dom";
import { useAppStore } from "../../stores/RootStore";
import { Separator } from "../../ui/Separator";
import ManagmentGrid from "./ManagmentGrid";
import { Header } from "../../components/Header";

type Props = {};

export const Managment = (props: Props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full">
      {location.pathname == "/managment" ? 
        <>
          <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
            <div className="flex text-base items-center gap-1">
              <NavLink to={"/"}>
                <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span> 
              </NavLink>
              <span>/</span> 
              <span className="font-medium">{t("managment")}</span>
            </div>
          </div>
          <Separator className="flex-none"/>
          <div className="flex flex-col w-full h-full max-w-[1008px] overflow-hidden">
            <Header name={t('managment')} backName={currentSite?.name ? currentSite?.name : "..."} backLink={"/"}/>
            <div className="px-6">
              <ManagmentGrid onClose={empty}/>
            </div>
          </div>
        </>
        : 
        <Outlet />
      }
    </div>
  );
};